import { useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";

import { usersKeys } from "../users";

export function AuthProvider() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(true);

  const searchParams = new URLSearchParams(location.search);
  const adminToken = searchParams.get("adminToken") || "";

  useEffect(() => {
    // If adminToken is available, set it in cookies as "token"
    if (adminToken) {
      Cookies.set("token", adminToken);
    }
    const token = Cookies.get("token");

    // If no token (either from cookies or adminToken), redirect to homepage
    if (!token || token === "null" || token === undefined) {
      void queryClient.removeQueries({ queryKey: usersKeys.all });
      navigate("/auth");
    } else {
      if (location.pathname === "/auth" || location.pathname === "/") {
        navigate("/user");
      }
    }

    setLoading(false);
  }, [adminToken]);
  // }, [adminToken, dispatch, fetchAuthDetails, location.pathname, navigate]);

  // Show loader while fetching auth details
  if (loading) return <div>...</div>;

  return <Outlet />;
}
